<template>
  <div class="register-container">
    <div class="header">
      <img class="register-img" :src="projectInfo.title" alt="">
      <h1 class="store-name txt-ellipsis">{{ activityInfo.customerName }}</h1>
    </div>

    <div class="form-content">
      <!-- Name -->
      <div class="form-item">
        <label class="label"><span class="required">*</span> Name</label>
        <div class="input-wrapper">
          <van-field v-model="formData.nickname" class="custom-field" :border="false" />
        </div>
      </div>

      <!-- Position -->
      <div class="form-item">
        <label class="label"><span class="required">*</span> Position</label>
        <div class="input-wrapper" @click="showPositionPicker = true">
          <van-field
            v-model="formData.job"
            readonly
            class="custom-field select-field"
            :class="{ 'placeholder': !formData.job }"
            :border="false"
            placeholder="Select"
          />
        </div>
      </div>

      <!-- Phone -->
      <div class="form-item">
        <label class="label"><span class="required">*</span> Phone</label>
        <div class="phone-wrapper">
          <!-- <van-field
            v-model="formData.countryCode"
            readonly
            clickable
            class="custom-field country-code-field"
            :border="false"
          /> -->
          <XuCountryCode class="country-code-field" v-model="formData.countryCode" />
          <van-field
            v-model="formData.phone"
            type="digit"
            maxlength="15"
            clickable
            class="custom-field phone-field"
            :border="false"
          />
        </div>
      </div>

      <!-- SMS -->
      <div class="form-item sms-item">
        <div class="input-wrapper">
          <van-field v-model="formData.code" class="custom-field" placeholder="SMS" :border="false" />
        </div>
        <span class="get-code-btn" :class="{ 'disabled': countdown > 0 }" @click="handleGetCode">
          {{ countdown > 0 ? `${countdown}s` : 'Get Verification Code' }}
        </span>
      </div>

      <!-- Agreement -->
      <!-- <div class="agreement-item">
        <van-checkbox v-model="formData.agreed" shape="round" icon-size="16px" checked-color="#ee541b">
          <div class="agreement-text">
            I agree to receive SMS messages from {{ projectInfo.brandName }} Incentive Program and have read the <a :href="projectInfo.termsAndCondition" target="_blank"><span class="link">Terms And Condition</span></a> and <a :href="projectInfo.privacyPolicy" target="_blank"><span class="link">Privacy Policy</span></a>
          </div>
        </van-checkbox>
      </div> -->

      <!-- <div class="agreement-item">
        <van-checkbox v-model="formData.agreed2" shape="round" icon-size="16px" checked-color="#ee541b">
          <div class="agreement-text">
            I agree to receive a one-time verification code and Account Authorization Opening Notification
          </div>
        </van-checkbox>
      </div> -->

      <!-- Submit Button -->
      <div class="submit-btn-wrapper">
        <van-button type="warning" block round class="submit-btn" @click="handleSubmit">
          Apply for Reward Eligibility
        </van-button>
      </div>

      <!-- Login Link -->
      <div class="login-link" @click="goToLogin">
        Already have an account,<span class="to-login"> log in</span>
      </div>
    </div>

    <!-- Position Picker -->
    <van-popup v-model="showPositionPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="positionOptions"
        @confirm="onPositionConfirm"
        @cancel="showPositionPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { activityEmployeeSendCodeApi, activityEmployeeRgisterApi, activityInfoApi } from '@/api'
import { mapMutations } from 'vuex'
export default {
  name: 'Register',
  components: {
    XuCountryCode: () => import('@/components/XuCountryCode')
  },
  data () {
    return {
      storeName: 'The Best Store',
      formData: {
        nickname: '',
        job: '',
        countryCode: '',
        phone: '',
        code: ''
        // agreed: false,
        // agreed2: false
      },
      showPositionPicker: false,
      positionOptions: ['Shopkeeper', 'Proc Mgr', 'Salesclerk'],
      countdown: 0,
      timer: null,
      shareKey: '',
      formRules: [
        { label: 'Name is Required', value: 'nickname' },
        { label: 'Position is Required', value: 'job' },
        { label: 'Phone is Required', value: 'countryCode' },
        { label: 'Phone is Required', value: 'phone' },
        { label: 'SMS is Required', value: 'code' }
        // { label: 'Please agree to the terms', value: 'agreed' },
        // { label: 'Please agree to the terms', value: 'agreed2' }
      ]
    }
  },
  created () {
    let url = window.location.href // 或直接使用完整URL
    if (process.env.NODE_ENV === 'development') {
      // url = 'https://voopoo-test.oss-cn-shenzhen.aliyuncs.com?shareKey=e3f2ab0e634a4d12df20521827f83345'
    } else {
      url = window.location.href // 或直接使用完整URL
    }
    // 当前页面的 URL
    const urlObj = new URL(url)

    // 优先从 search (标准 URL 参数) 获取
    let params = new URLSearchParams(urlObj.search)
    let key = params.get('shareKey')

    // 如果 search 中没有，尝试从 hash (Vue Hash 模式参数) 中获取
    // 例如: https://.../#/register?shareKey=...
    if (!key && urlObj.hash.includes('?')) {
      const hashPart = urlObj.hash.split('?')[1]
      if (hashPart) {
        params = new URLSearchParams(hashPart)
        key = params.get('shareKey')
      }
    }
    // 获取特定参数的值
    this.shareKey = key // 返回 'sada'
    this.getActivityInfo()
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    ...mapMutations(['setToken', 'setUSERINFO', 'setActivityInfo']),
    onPositionConfirm (value) {
      this.formData.job = value
      this.showPositionPicker = false
    },
    handleGetCode () {
      if (this.countdown > 0) return

      const { phone, countryCode } = this.formData
      if (!phone || !countryCode) {
        Toast('Please enter complete Phone number')
        return
      }

      // TODO: Implement get verification code logic
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityEmployeeSendCodeApi({ customerId: this.activityInfo.customerId, phone, countryCode }).then(res => {
        Toast.clear()
        this.formData.code = res.data
        this.countdown = 60
        this.timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      })
    },
    handleSubmit () {
      let isFlag = true
      this.formRules.find(subItem => {
        if (!this.formData[subItem.value]) {
          Toast(subItem.label)
          isFlag = false
          return subItem
        }
      })
      if (!isFlag) return

      // TODO: Implement registration logic
      Toast.success('Applied successfully')
      const data = {
        ...this.formData,
        customerId: this.activityInfo.customerId,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        shareUserId: this.activityInfo.shareUserId
      }
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityEmployeeRgisterApi(data).then(res => {
        Toast.clear()
        const { token, user, shareKey } = res.data
        this.setToken(token)
        this.setUSERINFO({ ...user, shareKey: shareKey, employeeId: this.activityInfo.employeeId })
        this.setActivityInfo({ ...this.activityInfo, shareKey })
        this.$router.push(`/activity/codeInfo?shareKey=${shareKey}`)
      })
    },
    goToLogin () {
      this.$router.push(`/login?shareKey=${this.shareKey}`)
    },
    getActivityInfo () {
      Toast.loading({
        message: 'loading...',
        forbidClick: true,
        duration: 0
      })
      activityInfoApi(this.shareKey).then(res => {
        Toast.clear()
        this.setActivityInfo(res.data)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.register-container {
  padding: 40px 13px 13px;
  background-color: #fff;
  min-height: 100vh;
  font-family: Arial, sans-serif;
  font-size: 12px;

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
    .register-img {
      width: 58px;
      // height: 58px;
      margin-bottom: 10px;
    }
    .store-name {
      width: 100%;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }
    .subtitle {
      font-size: 12px;
      color: #666;
    }
  }

  .form-content {
    .form-item {
      margin-bottom: 12px;

      .label {
        display: block;
        font-size: 13px;
        color: #333;
        margin-bottom: 3px;
        .required {
          color: #ee541b;
          margin-right: 4px;
        }
      }

      .input-wrapper {
        width: 100%;
      }

      .custom-field {
        width: 100%;
        height: 32px;
        border: 1px solid #dce5f6;
        border-radius: 8px;
        padding: 0 12px; // Keep minimal horizontal padding
        // font-size: 16px; // Vant default is usually fine, adjust if needed
        box-sizing: border-box;
        // outline: none; // Not needed for Vant component
        color: #323233;
        display: flex;
        align-items: center;

        // Reset Vant field padding to match height centering
        /deep/ .van-field__control {
          height: 100%;
          line-height: normal; // Reset line-height to allow flex centering if needed
        }

        // Remove default padding from Vant field to rely on container padding or set specific
        &.van-cell {
          padding: 0 12px;
          line-height: 42px; // Center content vertically
        }

        &::placeholder {
          color: #c8c9cc;
        }

        &.select-field {
           // line-height: 42px; // handled by .van-cell above
           /deep/ .van-field__control:disabled {
              color: #323233; // Make readonly look like normal text
              -webkit-text-fill-color: #323233;
           }
          &.placeholder {
             /deep/ .van-field__control {
               color: #c8c9cc;
               -webkit-text-fill-color: #c8c9cc;
             }
          }
        }
      }

      .phone-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .phone-field {
          flex: 1;
          // text-align: center; // Vant uses text-align on input
          padding: 0 10px;
          border-radius: 8px; // Slight radius for focus effect
          transition: border-color 0.2s;
          border: 1px solid #dce5f6; // Default border color

          &.is-focused {
             border-color: #ee541b;
             background-color: #fff;
             box-shadow: 0 0 4px rgba(238, 84, 27, 0.2);
          }

          /deep/ .van-field__control {
            //  text-align: center;
          }
        }

        .country-code-field {
          width: 100px;
          margin-right: 10px;
        }

        .separator {
          margin: 0 8px;
          color: #999;
        }
      }
    }

    .sms-item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .input-wrapper {
        flex: 1;
        margin-right: 15px;
      }

      .get-code-btn {
        color: #ee541b;
        font-size: 12px;
        white-space: nowrap;
        cursor: pointer;

        &.disabled {
          color: #999;
          cursor: not-allowed;
        }
      }
    }

    .agreement-item {
      margin-bottom: 16px;

      /deep/ .van-checkbox__label {
        line-height: 1.4;
      }

      .agreement-text {
        padding-left: 10px;
        font-size: 12px;
        color: #333;

        .link {
          color: #307bff;
          text-decoration: underline;
        }
      }
      /deep/.van-checkbox__icon .van-icon {
        width: 20px;
        height: 20px;
        line-height: 20px;
      }
    }

    .submit-btn-wrapper {
      margin-bottom: 16px;
      .submit-btn {
        height: 48px;
        background-color: #ee541b;
        border-color: #ee541b;
        /deep/.van-button__text {
          font-size: 18px;
        }
      }
    }

    .login-link {
      text-align: center;
      font-size: 12px;
      .to-login {
        color: #ee541b;
      }
    }
  }
}
</style>
